export const appPermission = {
  projectCityAdmin: 1,
  classCreator: 2,
  premiumCreator: 3,
  freePremiumUser: 4,
  adminAccess: 5,
  adminSubscription: 6,
};
